import { format, differenceInDays } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';

export const useFormatDate = () => {
  const formatDate = (date: string | Date) => {
    if (!date) return '';
    return format(new Date(date), 'dd MMMM yyyy', { locale: fr });
  };

  const formatDateYear = (date: string | Date) => {
    if (!date) return '';
    return format(new Date(date), 'yyyy', { locale: fr });
  };

  const formatDateUs = (date: string | Date) => {
    if (!date) return '';
    return format(new Date(date), 'yyyy-MM-dd', { locale: enUS });
  };

  const formatDateTime = (date: string | Date) => {
    if (!date) return '';
    return format(new Date(date), 'dd MMMM yyyy HH:mm', { locale: fr });
  };

  const formatShortDate = (date: string | Date) => {
    if (!date) return '';
    const dateObj = new Date(date);
    return `${String(dateObj.getDate()).padStart(2, '0')}/${String(dateObj.getMonth() + 1).padStart(2, '0')}`;
  };

  const getDurationInDays = (
    startDate: string | Date,
    endDate: string | Date,
  ) => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.abs(differenceInDays(start, end));
  };

  return {
    formatDate,
    formatDateTime,
    formatShortDate,
    getDurationInDays,
    formatDateUs,
    formatDateYear,
  };
};
